import React from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import ProjectCard from "@/components/ProjectCard";
import CTABand from "@/components/CTABand";
import { opportunities } from "@/data/projects";

const Opportunities = () => (
  <div data-testid="opportunities-page">
    <SEO
      title="This Month's Curated UAE Opportunities"
      description="Explore curated UAE homes and investment opportunities across Dubai, Abu Dhabi and Ras Al Khaimah & Al Marjan Island — selected for lifestyle appeal, location strength and long-term ownership potential."
      path="/opportunities"
      keywords="luxury apartments for sale in Dubai, off-plan luxury property Dubai, Al Marjan Island property investment, Dubai rental yield analysis"
    />
    <PageHero
      eyebrow="Current Opportunities"
      title="This Month's Curated UAE Opportunities"
      intro="Explore curated UAE homes and investment opportunities across Dubai, Abu Dhabi and Ras Al Khaimah & Al Marjan Island — selected for lifestyle appeal, location strength and long-term ownership potential."
      testid="opportunities-hero"
    />
    <section className="pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="opportunities-grid">
        {opportunities.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 3) * 0.08}>
            <ProjectCard project={p} index={i} />
          </Reveal>
        ))}
      </div>
    </section>
    <CTABand testid="opportunities-cta" title="Can't see exactly what you're looking for?" subtitle="Much of what ACRE places never reaches public listing. Tell us the brief and we will curate privately." />
  </div>
);

export default Opportunities;
